export const CURRENCY_SYMBOLS = { TRY: "₺", USD: "$", EUR: "€" };

export function formatMoney(amount, currency = "TRY", opts = {}) {
  const num = Number(amount || 0);
  const sym = CURRENCY_SYMBOLS[currency] || "";
  const abs = Math.abs(num);
  const formatted = abs.toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const sign = num < 0 ? "-" : "";
  if (opts.suffix) return `${sign}${formatted} ${currency}`;
  return `${sign}${sym}${formatted}`;
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
